import { Directive, Injectable, Input, ModuleWithProviders, NgModule, OnChanges, SimpleChanges, TemplateRef, ViewContainerRef } from '@angular/core';

export interface AbTestOptions {
  [key: string]: any;
}

@Injectable({ providedIn: 'root' })
export class AbTestsService {
  private readonly versions = new Map<string, string>();

  setVersion(testName: string, version: string) {
    if (!testName || !version) {
      return;
    }
    this.versions.set(testName, version);
  }

  getVersion(testName: string): string {
    return this.versions.get(testName) || 'A';
  }

  getVariation(testName: string): string {
    return this.getVersion(testName);
  }
}

@Directive({
  selector: '[abTestVersion]',
  standalone: false
})
export class AbTestVersionDirective implements OnChanges {
  @Input() abTestVersion = '';
  @Input() abTestVersionScope = '';

  constructor(
    private readonly templateRef: TemplateRef<unknown>,
    private readonly viewContainer: ViewContainerRef,
    private readonly abTestsService: AbTestsService
  ) {}

  ngOnChanges(_changes: SimpleChanges): void {
    const activeVersion = this.abTestsService.getVersion(this.abTestVersionScope);
    this.viewContainer.clear();
    if (this.abTestVersion === activeVersion) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }
}

@NgModule({
  declarations: [AbTestVersionDirective],
  exports: [AbTestVersionDirective]
})
export class AbTestsModule {
  static forRoot(_options?: AbTestOptions): ModuleWithProviders<AbTestsModule> {
    return { ngModule: AbTestsModule };
  }
}

@NgModule({
  imports: [AbTestsModule],
  exports: [AbTestsModule]
})
export class AbTestModule {
  static forRoot(_options?: AbTestOptions): ModuleWithProviders<AbTestModule> {
    return { ngModule: AbTestModule };
  }
}
